/* ============================================================================
   OTF — the search sheet.  2026-10-02 (Bu Site)
   CEO, from a screen recording: "The search button result is not smooth at
   all. It opens the keyboard and the page hides all its details. Fix that by
   applying the best way possible and see if we can do a smart search upgrade.
   Something that seems like ai but miniature."

   WHAT WAS WRONG. fluid-motion.js built search as a full-screen fixed layer
   (.fluid-srch) with the field at the top. On a phone the keyboard rose, the
   layer covered the whole page, and until two letters were typed and a
   network round-trip answered, the customer looked at an empty screen that
   said "Type a flower, a colour, or an occasion." Nothing of the shop was
   visible.

   WHAT THIS IS. A half-height sheet that rises from the tab bar and rides the
   keyboard (visualViewport), so the page stays in view above it. It is useful
   before a letter is typed - occasions, budgets and the bestsellers are on it
   - and it answers every keystroke instantly from an index of the whole range
   fetched ONCE per session (/collections/our-bouquets?view=index, rendered
   in the customer's language). The "miniature AI":
     - it reads intent out of plain words in English and Kuwaiti Arabic:
       occasions (birthday, mom, baby, graduation, love, wedding...), colours,
       flower and container words, and budgets ("under 30", "30 kd",
       "25 to 50", "cheap", "fancy", "أقل من 30");
     - it tolerates typos (one edit on words of five letters or more) and
       prefixes ("bir" finds birthday);
     - it says what it understood ("Birthday · under 30 KD · pink") so the
       customer can see the machine reading them;
     - when nothing matches it relaxes one constraint at a time (colour, then
       budget, then the loose words) and says so, instead of a dead end.
   A result tap morphs into the product sheet exactly like a card: a proxy
   card is placed inside the page at the result's rectangle and clicked, so
   fluid-motion.js's own sheetFromCard does the rest. On the product page,
   where no sheet opens, the tap navigates.

   WHY NOT AN EDIT TO fluid-motion.js. Same reason as otf-path.js and the
   five files before it: the stored and served copies differ, so it cannot be
   patched provably. The bar no longer renders .fluid-nav-search/.sgo, so the
   old search module in fluid-motion.js finds nothing to bind and stands down;
   its .fluid-srch CSS is simply unused. The bar's .searching state and the
   pillx close button are reused as they were.

   Strings come from #otf-search-strings in sections/fluid-bar.liquid.
   ========================================================================= */
(function () {
  'use strict';
  if (!document.querySelector) return;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var S = document.getElementById('otf-search-strings');
  function T(k, fb) { var v = S && S.getAttribute('data-' + k); return (v && v.trim()) || fb; }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function buzz(ms) { try { if (navigator.vibrate && !REDUCE) navigator.vibrate(ms); } catch (e) {} }
  var KD = AR ? ' د.ك' : ' KD';
  function money(n) { return (Math.round(n * 1000) / 1000).toFixed(3) + KD; }

  var nav = document.querySelector('.fluid-nav');
  var btn = document.querySelector('.otf-sgo');
  if (!nav || !btn) return;

  /* ---------------- the index ---------------- */
  var INDEX = null, loading = null;
  var KEY = 'otf_sidx_' + (AR ? 'ar' : 'en') + '_v1';
  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    try { var c = sessionStorage.getItem(KEY); if (c) { INDEX = prep(JSON.parse(c)); return Promise.resolve(INDEX); } } catch (e) {}
    loading = fetch(ROOT + 'collections/our-bouquets?view=index', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('index'); return r.text(); })
      .then(function (t) {
        var j = JSON.parse(t.trim());
        try { sessionStorage.setItem(KEY, JSON.stringify(j)); } catch (e) {}
        INDEX = prep(j); return INDEX;
      }).catch(function () { loading = null; return null; });
    return loading;
  }
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[ً-ْـ]/g, '')          /* Arabic diacritics, tatweel */
      .replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي')
      .replace(/[’'`]/g, '').replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim();
  }
  function prep(list) {
    return list.map(function (p) {
      p.nt = norm(p.t); p.nd = norm(p.d); p.tags = String(p.g || '').split(',');
      p.words = p.nt.split(' ').concat(p.nd.split(' ')).filter(Boolean);
      return p;
    });
  }

  /* ---------------- the reading of a query ---------------- */
  var OCC = {
    'birthday': ['birthday', 'bday', 'عيد ميلاد', 'ميلاد', 'يوم ميلاد'],
    'love': ['love', 'anniversary', 'valentine', 'romantic', 'romance', 'حب', 'ذكري', 'فالنتاين', 'حبيب', 'عشق'],
    'new-baby': ['baby', 'newborn', 'born', 'مولود', 'بيبي', 'ولاده', 'نفاس', 'طفل'],
    'graduation': ['graduation', 'graduate', 'grad', 'تخرج', 'نجاح', 'خريج'],
    'for-mom': ['mom', 'mum', 'mother', 'mama', 'للام', 'ماما', 'امي', 'الام', 'يمه', 'ام'],
    'wedding': ['wedding', 'bride', 'bridal', 'عرس', 'زواج', 'عروس', 'ملجه', 'ملكه'],
    'masarra': ['masarra', 'مسره'],
    'plants': ['plant', 'plants', 'orchid', 'نبات', 'نبته', 'اوركيد', 'نباتات'],
    'hand-bouquet': ['hand bouquet', 'hand', 'بوكيه', 'باقه يد', 'باقات اليد', 'اليد'],
    'cash-gift': ['cash', 'money', 'فلوس', 'كاش', 'نقديه', 'نقود'],
    'zodiac': ['zodiac', 'برج', 'ابراج'],
    'ramadan': ['ramadan', 'رمضان', 'eid', 'عيد الفطر', 'العيد']
  };
  var COL = {
    'red': ['red', 'احمر', 'حمرا', 'حمراء'], 'pink': ['pink', 'وردي', 'زهري', 'بينك'], 'white': ['white', 'ابيض', 'بيضا', 'بيضاء'],
    'blue': ['blue', 'ازرق', 'زرقا', 'زرقاء', 'بلو'], 'gold': ['gold', 'golden', 'ذهبي', 'قولد'], 'peach': ['peach', 'خوخي', 'بيتش'],
    'purple': ['purple', 'lilac', 'بنفسجي', 'موف', 'ليلكي'], 'green': ['green', 'اخضر', 'خضرا', 'خضراء']
  };
  var FLOWERS = {
    'rose': ['rose', 'roses', 'ورد', 'ورده', 'وردات', 'جوري'], 'tulip': ['tulip', 'tulips', 'توليب', 'تيوليب'],
    'orchid': ['orchid', 'orchids', 'phalaenopsis', 'اوركيد', 'اوركيدا'], 'lily': ['lily', 'lilies', 'ليلي', 'زنبق'],
    'gypsophila': ['gypsophila', 'gypso', 'babys breath', 'baby breath', 'جبسوفيليا', 'جيبسو'], 'hydrangea': ['hydrangea', 'هيدرانجيا', 'هدرانجيا'],
    'sunflower': ['sunflower', 'sunflowers', 'دوار الشمس', 'عباد الشمس'], 'peony': ['peony', 'peonies', 'فاوانيا'],
    'box': ['box', 'بوكس', 'علبه', 'صندوق'], 'basket': ['basket', 'سله', 'سلال'], 'vase': ['vase', 'فازه', 'مزهريه'],
    'tray': ['tray', 'صينيه'], 'balloon': ['balloon', 'balloons', 'بالون', 'بالونات'], 'chocolate': ['chocolate', 'شوكولاته', 'شوكلاته', 'جوكليت'],
    'bouquet': ['bouquet', 'bouquets', 'باقه', 'باقات', 'بوكيه'], 'stand': ['stand', 'ستاند'], 'teddy': ['teddy', 'bear', 'دبدوب', 'دب']
  };
  var STOP = ['a', 'an', 'the', 'for', 'of', 'with', 'and', 'some', 'something', 'nice', 'flowers', 'flower', 'bouquet', 'bouquets', 'i', 'want', 'need', 'please', 'kd', 'kwd', 'dinar',
    'ابي', 'ابغي', 'اريد', 'شي', 'حلو', 'حلوه', 'ورود', 'زهور', 'باقه', 'باقات', 'لو', 'سمحت', 'من', 'في', 'على', 'الى', 'او', 'و', 'دينار', 'بسعر'];
  function findIn(dict, q) {
    var hits = [];
    Object.keys(dict).forEach(function (key) {
      for (var i = 0; i < dict[key].length; i++) {
        var w = norm(dict[key][i]);
        var re = new RegExp('(^|\\s)(ال)?' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\s|$)');
        if (re.test(q)) { hits.push({ key: key, word: w }); return; }
      }
    });
    return hits;
  }
  function read(raw) {
    var q = norm(raw);
    var r = { occ: [], col: [], flw: [], min: 0, max: 0, free: [], q: q };
    var m;
    var budgetRe = [
      [/(?:^|\s)(?:under|below|less than|max|up to|cheaper than|اقل من|تحت|باقل من)\s*(\d+)/, function (x) { r.max = +x[1]; }],
      [/(?:^|\s)(?:over|above|more than|at least|min|اكثر من|فوق)\s*(\d+)/, function (x) { r.min = +x[1]; }],
      [/(\d+)\s*(?:to|-|–|الى|لين)\s*(\d+)/, function (x) { r.min = +x[1]; r.max = +x[2]; }],
      [/(?:^|\s)(\d+)(?:\s*(?:kd|kwd|دك|د ك|dinar|دينار))?(?:\s|$)/, function (x) { r.max = +x[1]; }]
    ];
    for (var i = 0; i < budgetRe.length; i++) { m = budgetRe[i][0].exec(q); if (m) { budgetRe[i][1](m); q = q.replace(m[0], ' '); break; } }
    if (/(^|\s)(cheap|budget|affordable|رخيص|رخيصه)(\s|$)/.test(q)) { r.max = r.max || 25; q = q.replace(/(cheap|budget|affordable|رخيص|رخيصه)/, ' '); }
    if (/(^|\s)(luxury|luxurious|fancy|premium|big|huge|grand|فخم|فخمه|كبير|كبيره|فاخر|فاخره)(\s|$)/.test(q)) { r.min = r.min || 100; q = q.replace(/(luxury|luxurious|fancy|premium|big|huge|grand|فخم|فخمه|كبير|كبيره|فاخر|فاخره)/, ' '); }
    findIn(OCC, q).forEach(function (h) { r.occ.push(h.key); q = q.replace(new RegExp('(^|\\s)(ال)?' + h.word + '(?=\\s|$)'), ' '); });
    findIn(COL, q).forEach(function (h) { r.col.push(h.key); q = q.replace(new RegExp('(^|\\s)(ال)?' + h.word + '(?=\\s|$)'), ' '); });
    findIn(FLOWERS, q).forEach(function (h) { r.flw.push(h.key); q = q.replace(new RegExp('(^|\\s)(ال)?' + h.word + '(?=\\s|$)'), ' '); });
    r.free = q.split(' ').filter(function (w) { return w && STOP.indexOf(w) < 0 && STOP.indexOf(w.replace(/^ال/, '')) < 0 && w.length > 1; });
    return r;
  }
  function lev1(a, b) {       /* true when a and b are within one edit */
    if (a === b) return true;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (la > lb) i++; else if (lb > la) j++; else { i++; j++; }
    }
    return edits + (la - i) + (lb - j) <= 1;
  }
  function wordScore(w, p) {     /* how well one free word fits one product */
    var best = 0, words = p.words, i, x;
    var w2 = w.replace(/^ال/, '');
    for (i = 0; i < words.length; i++) {
      x = words[i];
      if (x === w || x === w2) { best = Math.max(best, 3); continue; }
      if (w2.length >= 3 && x.indexOf(w2) === 0) { best = Math.max(best, 2); continue; }
      if (w2.length >= 4 && x.length >= 4 && lev1(w2, x)) best = Math.max(best, 1.5);
    }
    if (!best && w2.length >= 3 && (p.nt.indexOf(w2) > -1)) best = 1;
    if (!best && w2.length >= 4 && (p.nd.indexOf(w2) > -1)) best = 0.5;
    return best;
  }
  var FLOWER_TITLE = { rose: ['rose', 'ورد', 'جوري'], tulip: ['tulip', 'توليب'], orchid: ['orchid', 'phalaenopsis', 'اوركيد'], lily: ['lil', 'ليلي'], gypsophila: ['gyps', 'baby', 'جبس'], hydrangea: ['hydrangea', 'هيدرانج'], sunflower: ['sunflower', 'الشمس'], peony: ['peon', 'فاوانيا'], box: ['box', 'بوكس', 'علبه'], basket: ['basket', 'سله'], vase: ['vase', 'فازه'], tray: ['tray', 'صينيه'], balloon: ['balloon', 'بالون'], chocolate: ['choc', 'شوكو'], bouquet: ['bouquet', 'باقه'], stand: ['stand', 'ستاند'], teddy: ['teddy', 'bear', 'دب'] };
  function flowerHit(k, p) { var t = FLOWER_TITLE[k] || [k]; var hay = p.nt + ' ' + p.nd; for (var i = 0; i < t.length; i++) if (hay.indexOf(norm(t[i])) > -1) return true; return false; }

  function rank(r, relax) {       /* relax: 0 none, 1 drop colour, 2 drop budget, 3 drop free words */
    var out = [];
    INDEX.forEach(function (p) {
      var s = 0, i, ok = true;
      if (r.occ.length) { var oh = 0; for (i = 0; i < r.occ.length; i++) if (p.tags.indexOf(r.occ[i]) > -1) oh++; if (!oh) ok = false; else s += 3 * oh; }
      if (ok && r.col.length && relax < 1) { var ch = 0; for (i = 0; i < r.col.length; i++) if (p.tags.indexOf(r.col[i]) > -1 || flowerHit(r.col[i], p)) ch++; if (!ch) ok = false; else s += 2 * ch; }
      if (ok && relax < 2) { if (r.max && p.p > r.max) ok = false; if (r.min && p.p < r.min) ok = false; }
      if (ok && r.flw.length) { var fh = 0; for (i = 0; i < r.flw.length; i++) if (flowerHit(r.flw[i], p)) fh++; if (!fh) ok = false; else s += 2.5 * fh; }
      if (ok && r.free.length && relax < 3) { var ws = 0, hitAny = false; for (i = 0; i < r.free.length; i++) { var w = wordScore(r.free[i], p); if (w) { hitAny = true; ws += w; } } if (!hitAny) ok = false; else s += ws; }
      if (!ok) return;
      if (p.tags.indexOf('bestseller') > -1) s += 0.5;
      if (!p.a) s -= 5;
      out.push({ p: p, s: s });
    });
    out.sort(function (a, b) { return b.s - a.s || a.p.p - b.p.p; });
    return out.map(function (x) { return x.p; });
  }
  function search(raw) {
    var r = read(raw);
    var nothingAsked = !r.occ.length && !r.col.length && !r.flw.length && !r.min && !r.max && !r.free.length;
    if (nothingAsked) return { r: r, list: [], relaxed: 0, empty: true };
    /* relax one constraint at a time - but only while something else is
       still being asked for; a lone unknown word has no "rest" to fall back on */
    var hasOther = r.occ.length || r.flw.length || r.min || r.max;
    var maxRelax = (r.free.length && !hasOther && !r.col.length) ? 0 : (r.free.length && !hasOther ? 1 : 3);
    for (var relax = 0; relax <= maxRelax; relax++) {
      var list = rank(r, relax);
      if (list.length) return { r: r, list: list, relaxed: relax };
    }
    return { r: r, list: [], relaxed: 4 };
  }

  /* ---------------- the sheet ---------------- */
  var sheet = null, scrim = null, input = null, body = null, under = null, open = false, lockY = 0, lastQ = '', deb = 0;
  var tryList = (T('try', '') || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean).map(function (x) { var i = x.indexOf('='); return { tag: x.slice(0, i).trim(), label: x.slice(i + 1).trim() }; }).filter(function (x) { return x.tag && x.label; });
  var occLabels = {}; tryList.forEach(function (x) { occLabels[x.tag] = x.label; });
  function labelFor(key) { return occLabels[key] || key; }
  function build() {
    scrim = document.createElement('div'); scrim.className = 'otf-ss-scrim';
    sheet = document.createElement('div'); sheet.className = 'otf-ss'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-label', T('title', 'Find a bouquet'));
    sheet.innerHTML =
      '<div class="ss-grab" aria-hidden="true"></div>' +
      '<div class="ss-head">' +
        '<label class="ss-field"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M15.8 15.8 L20 20"/></svg>' +
        '<input class="ss-in" type="search" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="search" placeholder="' + esc(T('ph', 'Search flowers, occasions')) + '" aria-label="' + esc(T('title', 'Find a bouquet')) + '">' +
        '<button class="ss-clear" type="button" hidden aria-label="' + esc(T('clear', 'Clear')) + '">&times;</button></label>' +
        '<button class="ss-cancel" type="button">' + esc(T('cancel', 'Cancel')) + '</button>' +
      '</div>' +
      '<div class="ss-under" data-under></div>' +
      '<div class="ss-body" data-body></div>';
    document.body.appendChild(scrim); document.body.appendChild(sheet);
    input = sheet.querySelector('.ss-in'); body = sheet.querySelector('[data-body]'); under = sheet.querySelector('[data-under]');
    input.addEventListener('input', function () { clearTimeout(deb); var v = input.value; sheet.querySelector('.ss-clear').hidden = !v; deb = setTimeout(function () { run(v); }, 60); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var v = input.value.trim(); if (v.length >= 2) location.href = ROOT + 'search?q=' + encodeURIComponent(v); } });
    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.ss-cancel')) { close(); return; }
      if (t.closest('.ss-clear')) { input.value = ''; sheet.querySelector('.ss-clear').hidden = true; run(''); input.focus(); return; }
      var chip = t.closest('[data-q]'); if (chip) { buzz(6); input.value = chip.getAttribute('data-q'); sheet.querySelector('.ss-clear').hidden = false; run(input.value); return; }
      var card = t.closest('.otf-sr'); if (card) { buzz(8); openProduct(card); return; }
      var all = t.closest('.ss-all'); if (all) { return; }
    });
    scrim.addEventListener('click', close);
    var pillx = nav.querySelector('.pillx'); if (pillx) pillx.addEventListener('click', function () { if (open) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) close(); });
    if (window.visualViewport) { visualViewport.addEventListener('resize', fit); visualViewport.addEventListener('scroll', fit); }
  }
  function fit() {
    if (!open || !sheet) return;
    var vv = window.visualViewport, off = 0, vh = innerHeight;
    if (vv) { off = Math.max(0, innerHeight - vv.height - vv.offsetTop); vh = vv.height; }
    var kb = off > 90;
    sheet.style.bottom = (kb ? off + 10 : 0) + 'px';
    sheet.classList.toggle('kb', kb);
    sheet.style.maxHeight = Math.round(vh * (kb ? 0.92 : 0.72)) + 'px';
  }
  function lock() { lockY = scrollY; document.body.style.position = 'fixed'; document.body.style.top = (-lockY) + 'px'; document.body.style.left = '0'; document.body.style.right = '0'; document.body.style.overflow = 'hidden'; }
  function unlock() { document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = ''; document.body.style.overflow = ''; scrollTo(0, lockY); }
  function tell(o) { document.dispatchEvent(new CustomEvent('otfsearch', { detail: { open: o } })); }
  function openSheet() {
    if (open) return;
    if (!sheet) build();
    open = true; buzz(8);
    lock();
    nav.classList.add('searching');
    scrim.classList.add('on'); sheet.classList.add('on');
    fit();
    renderEmpty();
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    loadIndex().then(function () { if (open && input.value) run(input.value); else if (open) renderEmpty(); });
    tell(true);
  }
  function close() {
    if (!open) return;
    open = false;
    try { input.blur(); } catch (e) {}
    nav.classList.remove('searching');
    scrim.classList.remove('on'); sheet.classList.remove('on');
    sheet.style.bottom = ''; sheet.classList.remove('kb');
    unlock();
    tell(false);
  }
  btn.addEventListener('click', function (e) { e.preventDefault(); if (open) close(); else openSheet(); });
  window.otfSearchClose = close;

  /* ---------------- rendering ---------------- */
  function card(p) {
    return '<button class="otf-sr fluid-press" type="button" data-handle="' + esc(p.h) + '" data-title="' + esc(p.t) + '" data-price="' + esc(money(p.p)) + '" data-note="' + esc(p.d) + '" data-img="' + esc(p.m) + '" data-amb="' + esc(p.i) + '" data-variant="' + esc(p.v) + '" data-available="' + (p.a ? 'true' : 'false') + '" data-topok="true" aria-label="' + esc(p.t) + ', ' + esc(money(p.p)) + '">' +
      '<img src="' + esc(p.i) + '" alt="" loading="lazy"><span class="veil"></span><span class="in"><b>' + esc(p.t) + '</b><small>' + esc(money(p.p)) + '</small></span></button>';
  }
  function tonightLine() {
    var kw = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kuwait' }));
    return kw.getHours() < 21 ? T('tonight', 'Order by 9 pm and it arrives tonight.') : T('tomorrow', 'Order now and it arrives tomorrow.');
  }
  function renderEmpty() {
    under.innerHTML = '<p class="ss-hello"><i aria-hidden="true"></i>' + esc(tonightLine()) + '</p>';
    var chips = tryList.map(function (x) { return '<button class="ss-chip" type="button" data-q="' + esc(x.label) + '">' + esc(x.label) + '</button>'; }).join('');
    var pop = '';
    if (INDEX) {
      var best = INDEX.filter(function (p) { return p.a && p.tags.indexOf('bestseller') > -1; }).slice(0, 8);
      if (best.length) pop = '<p class="ss-lbl">' + esc(T('popular', 'Popular now')) + '</p><div class="ss-grid">' + best.map(card).join('') + '</div>';
    } else pop = '<div class="ss-wait" aria-hidden="true"><span></span><span></span><span></span></div>';
    body.innerHTML = '<p class="ss-lbl">' + esc(T('trylbl', 'Try')) + '</p><div class="ss-chips">' + chips + '</div>' + pop;
    body.scrollTop = 0;
  }
  function understood(r) {
    var bits = [];
    r.occ.forEach(function (k) { bits.push(labelFor(k)); });
    r.col.forEach(function (k) { bits.push(T('c-' + k, k)); });
    r.flw.forEach(function (k) { bits.push(T('f-' + k, k)); });
    if (r.min && r.max) bits.push(r.min + ' – ' + r.max + KD);
    else if (r.max) bits.push(T('under', 'under _N_').replace('_N_', r.max + KD));
    else if (r.min) bits.push(T('over', 'over _N_').replace('_N_', r.min + KD));
    r.free.forEach(function (w) { bits.push('“' + w + '”'); });
    return bits;
  }
  function run(v) {
    lastQ = v;
    if (!v.trim()) { renderEmpty(); return; }
    if (!INDEX) { under.innerHTML = ''; body.innerHTML = '<div class="ss-wait" aria-hidden="true"><span></span><span></span><span></span></div>'; loadIndex().then(function () { if (open && input.value === v) run(v); }); return; }
    var res = search(v);
    var bits = understood(res.r);
    var head = '<span class="ss-read">' + esc(T('reading', 'Looking for')) + '</span>' + bits.map(function (b) { return '<span class="ss-tok">' + esc(b) + '</span>'; }).join('');
    var note = '';
    if (res.relaxed === 1) note = T('nocolour', 'Not in that colour, so here is everything else that fits.');
    else if (res.relaxed === 2) note = T('nobudget', 'Nothing at that price, so here is the closest.');
    else if (res.relaxed === 3) note = T('noword', 'Nothing with that word, so here is what fits the rest.');
    under.innerHTML = '<div class="ss-understood">' + head + '</div>' + (note ? '<p class="ss-note">' + esc(note) + '</p>' : '');
    if (res.empty) { renderEmpty(); return; }
    if (!res.list.length) {
      body.innerHTML = '<p class="ss-none">' + esc(T('none', 'Nothing matched that. Try a colour, an occasion, or a name.')) + '</p>' +
        '<div class="ss-chips">' + tryList.slice(0, 6).map(function (x) { return '<button class="ss-chip" type="button" data-q="' + esc(x.label) + '">' + esc(x.label) + '</button>'; }).join('') + '</div>';
      return;
    }
    var shown = res.list.slice(0, 12);
    var n = res.list.length;
    var countStr = (AR && n >= 3 && n <= 10) ? T('countfew', '_N_ باقات') : (AR && n === 1 ? T('countone', 'باقة وحدة') : (AR && n === 2 ? T('counttwo', 'باقتين') : T('count', '_N_ bouquets')));
    body.innerHTML = '<p class="ss-lbl">' + esc(countStr.replace('_N_', n)) + '</p>' +
      '<div class="ss-grid">' + shown.map(card).join('') + '</div>' +
      (res.list.length > shown.length ? '<a class="ss-all" href="' + esc(ROOT + 'search?q=' + encodeURIComponent(v.trim())) + '">' + esc(T('all', 'See all results')) + '</a>' : '');
    body.scrollTop = 0;
  }

  /* ---------------- a result opens the product sheet ---------------- */
  var proxy = null, proxyMo = null;
  function openProduct(el) {
    var host = document.querySelector('.fluid-home-wrap, .fluid-page-wrap');
    var h = el.getAttribute('data-handle');
    if (!host || document.querySelector('.fluid-page.fluid-pdp')) { if (window.fluidLoad) window.fluidLoad(true); location.href = ROOT + 'products/' + h; return; }
    var r = el.getBoundingClientRect();
    close();
    if (proxy && proxy.parentNode) proxy.parentNode.removeChild(proxy);
    proxy = document.createElement('button');
    proxy.className = 'fluid-gcard otf-sproxy'; proxy.type = 'button';
    ['data-handle', 'data-title', 'data-price', 'data-note', 'data-img', 'data-amb', 'data-variant', 'data-available', 'data-topok'].forEach(function (a) { proxy.setAttribute(a, el.getAttribute(a) || ''); });
    proxy.style.cssText = 'position:fixed;left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;z-index:1;opacity:0;pointer-events:none;margin:0';
    host.appendChild(proxy);
    setTimeout(function () { proxy.click(); }, 40);
    /* take the proxy away once the sheet it opened has closed */
    if (!proxyMo && window.MutationObserver) {
      proxyMo = new MutationObserver(function () {
        if (proxy && proxy.parentNode && !document.querySelector('.fluid-sheet')) {
          var p = proxy; setTimeout(function () { if (p.parentNode && !document.querySelector('.fluid-sheet')) p.parentNode.removeChild(p); }, 500);
        }
      });
      proxyMo.observe(document.body, { childList: true });
    }
  }
})();
